import { Component, OnInit } from '@angular/core';
import { Client } from 'src/app/services/API/client';
import { toastrService } from 'src/app/services/ux/toastr.service';

@Component({
  templateUrl: './postal-component.component.html'
})
export class PostalComponent implements OnInit {

  cities: any; //qytetet
  offices: any; //zyrat postare
  loading = false;
  selectedValue: any;

  constructor(
    private client: Client,
    private toastr: toastrService
  ) { }

  ngOnInit() {
    this.getCities();
  }

  //therret API dhe merr qytetet
  getCities(){

    //API call
    this.client.get('api/cities')

    //get cities
    .then((res: any) => {
      this.cities = res;

    })

    //catch errors
    .catch((err: any) => {
      return err;
    });

  }

  //therret API dhe merr informacion per post offices
  getPostOffices(id){
    this.loading = true;
    //API call
    this.client.get('api/cities/'+ id + '/offices')

    //get office info
    .then((res: any) => {
      this.offices = res;
      this.loading = false;
    })

    //catch errors
    .catch((err: any) => {
      this.loading = false;
      this.toastr.error("Ju lutem zgjidhni nje qytet!");
    });
  }

}